(() => {
  const slugify = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  };

  const initializeArticle = (root) => {
    const content = root.querySelector(
      "[data-rsl-article-content]"
    );
    const toc = root.querySelector("[data-rsl-toc]");
    const tocList = root.querySelector(
      "[data-rsl-toc-list]"
    );

    if (content && toc && tocList) {
      const headings = Array.from(
        content.querySelectorAll("h2")
      );
      const usedIds = new Set();

      headings.forEach((heading, index) => {
        let id =
          heading.id ||
          slugify(heading.textContent) ||
          `section-${index + 1}`;

        const baseId = id;
        let duplicateNumber = 2;

        while (
          usedIds.has(id) ||
          (
            document.getElementById(id) &&
            document.getElementById(id) !== heading
          )
        ) {
          id = `${baseId}-${duplicateNumber}`;
          duplicateNumber += 1;
        }

        heading.id = id;
        usedIds.add(id);

        const item = document.createElement("li");
        const link = document.createElement("a");

        link.href = `#${id}`;
        link.textContent = heading.textContent.trim();

        item.appendChild(link);
        tocList.appendChild(item);
      });

      if (headings.length >= 2) {
        toc.hidden = false;

        if ("IntersectionObserver" in window) {
          const links = Array.from(
            tocList.querySelectorAll("a")
          );

          const linkById = new Map(
            links.map((link) => [
              link.hash.slice(1),
              link
            ])
          );

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;

                links.forEach((link) => {
                  link.classList.remove("is-active");
                });

                const activeLink = linkById.get(
                  entry.target.id
                );

                if (activeLink) {
                  activeLink.classList.add("is-active");
                }
              });
            },
            {
              rootMargin: "-20% 0px -68% 0px",
              threshold: 0
            }
          );

          headings.forEach((heading) => {
            observer.observe(heading);
          });
        }
      }
    }

    root
      .querySelectorAll("[data-rsl-ring-carousel]")
      .forEach((carousel) => {
        const track = carousel.querySelector(
          "[data-rsl-ring-track]"
        );

        const previousButton = carousel.querySelector(
          "[data-rsl-ring-prev]"
        );

        const nextButton = carousel.querySelector(
          "[data-rsl-ring-next]"
        );

        if (
          !track ||
          !previousButton ||
          !nextButton
        ) {
          return;
        }

        const updateButtons = () => {
          const maximumScroll = Math.max(
            0,
            track.scrollWidth - track.clientWidth
          );

          previousButton.disabled =
            track.scrollLeft <= 4;

          nextButton.disabled =
            track.scrollLeft >= maximumScroll - 4;
        };

        const move = (direction) => {
          const card = track.querySelector(
            ".rsl-rings__card"
          );

          if (!card) return;

          const styles =
            window.getComputedStyle(track);

          const gap =
            Number.parseFloat(
              styles.columnGap || styles.gap
            ) || 18;

          track.scrollBy({
            left:
              direction *
              (
                card.getBoundingClientRect().width +
                gap
              ),
            behavior: "smooth"
          });
        };

        previousButton.addEventListener(
          "click",
          () => move(-1)
        );

        nextButton.addEventListener(
          "click",
          () => move(1)
        );

        track.addEventListener(
          "scroll",
          updateButtons,
          { passive: true }
        );

        window.addEventListener(
          "resize",
          updateButtons,
          { passive: true }
        );

        window.requestAnimationFrame(
          updateButtons
        );
      });

    const copyButton = root.querySelector(
      "[data-rsl-copy-link]"
    );

    const copyStatus = root.querySelector(
      "[data-rsl-copy-status]"
    );

    if (copyButton && copyStatus) {
      copyButton.addEventListener(
        "click",
        async () => {
          try {
            await navigator.clipboard.writeText(
              window.location.href
            );

            copyStatus.textContent = "Copied";
          } catch (error) {
            copyStatus.textContent =
              "Please copy the address from your browser";
          }

          window.setTimeout(() => {
            copyStatus.textContent = "";
          }, 2600);
        }
      );
    }
  };

  const initializeAll = () => {
    document
      .querySelectorAll("[data-rsl-article]")
      .forEach(initializeArticle);
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeAll,
      { once: true }
    );
  } else {
    initializeAll();
  }
})();